<template>
  <v-list subheader >
    <v-subheader>Attendance</v-subheader>
    <v-list-item @click="openReport('/reportView/attendance/class')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/buyer.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Attendance Report By Class</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item @click="openReport('/reportView/attendance/student')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/buyer.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Attendance Report By Student</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  methods: {
    openReport(path) {
      let routeData = this.$router.resolve({
        path: path
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped></style>
